<template>
  <div class="main-div d-flex justify-content-start align-items-center">
    <div class="form">
      <div class="topelements">
        <div class="icons">
          <div v-if="currentStep > 1" class="arrow" @click="prevStep">
            <svg
              viewBox="0 -6.5 36 36"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <title>left-arrow</title>
                <desc>Created with Sketch.</desc>
                <g
                  id="icons"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="ui-gambling-website-lined-icnos-casinoshunter"
                    transform="translate(-342.000000, -159.000000)"
                    fill="#252528"
                    fill-rule="nonzero"
                  >
                    <g
                      id="square-filled"
                      transform="translate(50.000000, 120.000000)"
                    >
                      <path
                        d="M317.108012,39.2902857 L327.649804,49.7417043 L327.708994,49.7959169 C327.889141,49.9745543 327.986143,50.2044182 328,50.4382227 L328,50.5617773 C327.986143,50.7955818 327.889141,51.0254457 327.708994,51.2040831 L327.6571,51.2479803 L317.108012,61.7097143 C316.717694,62.0967619 316.084865,62.0967619 315.694547,61.7097143 C315.30423,61.3226668 315.30423,60.6951387 315.694547,60.3080911 L324.702666,51.3738496 L292.99947,51.3746291 C292.447478,51.3746291 292,50.9308997 292,50.3835318 C292,49.8361639 292.447478,49.3924345 292.99947,49.3924345 L324.46779,49.3916551 L315.694547,40.6919089 C315.30423,40.3048613 315.30423,39.6773332 315.694547,39.2902857 C316.084865,38.9032381 316.717694,38.9032381 317.108012,39.2902857 Z M327.115357,50.382693 L316.401279,61.0089027 L327.002151,50.5002046 L327.002252,50.4963719 L326.943142,50.442585 L326.882737,50.382693 L327.115357,50.382693 Z"
                        id="left-arrow"
                        transform="translate(310.000000, 50.500000) scale(-1, 1) translate(-310.000000, -50.500000) "
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>

          <div class="close-form" @click="closeForm">
            <svg
              viewBox="0 0 24 24"
              fill="#000000"
              xmlns="http://www.w3.org/2000/svg"
              style="padding-bottom: 6px"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                  fill="#0F0F0F"
                ></path>
              </g>
            </svg>
          </div>
        </div>

        <div class="title"><h5>Prefrences</h5></div>

        <div class="progress-percent">
          {{ Math.round((currentStep / totalSteps) * 100) }}%
        </div>

        <div class="progress-bar">
          <div
            class="progress"
            :style="{ width: (currentStep / totalSteps) * 100 + '%' }"
          ></div>
        </div>
      </div>
      <!-- <transition name="slide"> -->
      <div v-if="currentStep === 1" key="step-1">
        <h2 class="question mt-3 mb-3">What do you want to study?</h2>

        <div class="search">
          <input
            type="text"
            class="form-control"
            placeholder="Search"
            v-model="searchTerm"
          />
        </div>
        <div class="mt-5 step1">
          <CheckBox
            v-for="category in filteredSpecializations"
            :key="'category_' + category.id"
            :id="category.id"
            :title="category.name"
            :fields="category.fields"
            :checked="isCategorySelected(category.id)"
            :selectedFieldIds="filters.field_ids"
            @category-click="handleCategoryClick"
            @field-click="handleFieldClick"
          />
          <p
            v-if="filteredSpecializations.length === 0"
            class="text-muted mt-md-3 mt-1"
          >
            No results found.
          </p>
        </div>
        <span
          class="error-message"
          v-if="validationErrors.field"
          style="color: red"
        >
          {{ validationErrors.field }}
        </span>
      </div>

      <div v-if="currentStep === 2" key="step-2">
        <h2 class="question mt-2">Your Country Preference</h2>
        <div class="mt-5 country">
          <PillsCheck
            v-for="country in countries.slice(0, 5)"
            :title="country.country_name"
            :id="country.country_id"
            :checked="filters.country_ids.includes(country.country_id)"
            :key="'course_level_' + country.country_id"
            @checkbox-click="countrySelected"
            :border="'#5367ff'"
          />
          <PillsCheck
            v-for="country in countries.slice(5)"
            :title="country.country_name"
            :id="country.country_id"
            :checked="filters.country_ids.includes(country.country_id)"
            :key="'course_level_' + country.country_id"
            @checkbox-click="countrySelected"
          />
        </div>
        <span
          class="error-message"
          v-if="validationErrors.countries"
          style="color: red"
        >
          {{ validationErrors.countries }}
        </span>
      </div>

      <div v-if="currentStep === 3" key="step-3">
        <h2 class="question mt-2">Education level applying for</h2>
        <div class="mt-5 country step3">
          <PillsCheck
            v-for="course_level in courseLevels"
            :title="course_level.course_level_name"
            :id="course_level.course_level_id"
            :checked="
              filters.course_level_ids.includes(course_level.course_level_id)
            "
            :key="'course_level_' + course_level.course_level_id"
            @checkbox-click="courseLevelSelected"
          />
        </div>
        <span
          class="error-message"
          v-if="validationErrors.courseLevels"
          style="color: red"
        >
          {{ validationErrors.courseLevels }}
        </span>
      </div>

      <div v-if="currentStep === 4" key="step-4">
        <h2 class="question mt-2">When do you plan to start?</h2>
        <div class="mt-5">
          <div class="year">
            <div v-for="year in years" :key="'year_' + year" class="m-2">
              <!-- Year Selection -->
              <YearCheckBox
                :title="year"
                :id="year"
                :checked="filters.course_years.includes(year)"
                @checkbox-click="yearSelected"
              />

              <div v-if="filters.course_years.includes(year)" class="months">
                <PillsCheck
                  v-for="month in getMonthsForYear(year)"
                  :id="month"
                  :title="month"
                  :checked="filters.course_months.includes(month)"
                  @checkbox-click="monthSelected"
                  :key="'a' + month"
                />
              </div>
            </div>
            <span
              class="error-message"
              v-if="validationErrors.yearMonth"
              style="color: red"
            >
              {{ validationErrors.yearMonth }}
            </span>
          </div>
        </div>
      </div>

      <div v-if="currentStep === 5" class="step5" key="step-5">
        <h2 class="question mt-2">How can we reach you?</h2>
        <div class="d-flex justify-content-center">
          <div class="form-contact-div">
            <div class="form-ip">
              <div class="input-container">
                <input
                  id="name"
                  placeholder="Enter your name"
                  v-model="filters.name"
                  type="text"
                  name="name"
                  class="input"
                />
              </div>
            </div>

            <div class="form-ip">
              <div class="input-container">
                <input
                  placeholder="Enter email"
                  type="email"
                  id="email"
                  v-model="filters.email"
                  name="email"
                  class="input"
                  @blur="validateEmail"
                />
                <span>
                  <svg
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                      stroke-width="2"
                      stroke-linejoin="round"
                      stroke-linecap="round"
                    ></path>
                  </svg>
                </span>
              </div>
              <!-- <div class="email-verify" @click="sendCode">
                  <button class="btn-sendcode">Send Code</button>
                </div> -->
              <div class="otp-main">
                <div class="otp-container" v-if="show_otp">
                  <div class="close-otp close" @click="closeOtp">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="padding-bottom: 6px"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                          fill="#0F0F0F"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <h1>OTP Verification</h1>
                  <p>
                    Enter the OTP you received to
                    <span id="email">{{ filters.email }}</span>
                  </p>
                  <div class="">
                    <div class="otp-input">
                      <input
                        v-for="(value, index) in otp"
                        :key="index"
                        v-model="otp[index]"
                        @input="handleInput(index)"
                        @keydown="handleKeyDown($event, index)"
                        maxlength="1"
                        type="text"
                        class="otp-field"
                        ref="otp"
                        :ref="'otp' + index"
                      />
                    </div>
                  </div>
                  <span
                    class="error-message"
                    v-if="validationErrors.otp"
                    style="color: red"
                  >
                    {{ validationErrors.otp }}
                  </span>
                  <div class="mt-3">
                    <button class="btn" @click="verifyOTP">Verify</button>

                    <div
                      class="timer mt-3"
                      :class="{ expired: otpExpired }"
                      id="timer"
                    >
                      {{ timerDisplay }}
                    </div>

                    <!-- <p class="" @click="resendCode" v-if="otpExpired">
                        Resend Code
                      </p> -->
                  </div>
                </div>

                <div class="otp-container-v" v-if="show_verified">
                  <div class="div_image_v">
                    <div class="image">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M20 7L9.00004 18L3.99994 13"
                            stroke="#000000"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div class="text">
                      <div class="div_text_v">Otp Verified</div>
                      <p class="redirect">Redirecting...</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-ip">
              <div class="input-container">
                <input
                  id="phone"
                  placeholder="Enter Phone Number"
                  v-model="filters.phone"
                  type="text"
                  name="phone"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  maxlength="10"
                />
              </div>
            </div>
          </div>
        </div>
        <span
          class="error-message"
          v-if="validationErrors.email"
          style="color: red"
        >
          {{ validationErrors.email }}
        </span>
      </div>
      <!-- </transition> -->

      <div class="buttons mt-5">
        <button
          class="btn"
          @click="currentStep === totalSteps ? submitForm() : nextStep()"
        >
          Skip
        </button>
        <button
          v-if="currentStep < totalSteps"
          class="btn"
          @click="proceedToNextStep()"
        >
          Next
        </button>
        <button
          v-if="currentStep === totalSteps"
          class="btn code-btn"
          @click="sendCode()"
        >
          Send Code
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCheckbox from "@/components/pages/Search/helper/CustomCheckbox.vue";
import CheckBox from "./CheckBox.vue";
import { mapGetters, mapActions } from "vuex";
import {
  formSpecialization,
  countries,
  courseLevels,
} from "@/data/json/form-specialization.js";
import PillsCheck from "./PillsCheck.vue";
import YearCheckBox from "./YearCheckBox.vue";
import homeServices from "@/apiServices/homeServices";
import axios from "axios";
import { LMS_API, IMAGEURL, BASEURL } from "@/config/index";

export default {
  components: { CheckBox, CustomCheckbox, PillsCheck, YearCheckBox },
  data() {
    const currentDate = new Date();

    return {
      currentStep: 1,
      totalSteps: 5,
      searchTerm: "",
      email: "",
      otp: Array(4).fill(""),
      generatedOTP: "1234",
      show_otp: false,
      show_verified: false,
      timeLeft: 120, // 2 minutes in seconds
      timerId: null,
      otpExpired: false,
      canResend: false,
      validationErrors: {
        name: "",
        email: "",
        phone: "",
        countries: "",
        courseLevels: "",
        yearMonth: "",
        field: "",
        otp: "",
      },

      filters: {
        course_level_ids: [],
        course_level_names: [],
        course_category_ids: [],
        field_ids: [], // Subcategories
        field_names: [],
        course_category_names: [],
        country_ids: [],
        country_names: [],
        course_months: [],
        course_years: [],
        name: "",
        email: "",
        phone: "",
        search_text: "",
        name: "",
        email: "",
        phone: "",
      },

      formSpecialization: formSpecialization,
      countries: countries,
      courseLevels: courseLevels,
      currentYear: currentDate.getFullYear(),
      currentMonthIndex: currentDate.getMonth(),
      selectedYear: currentDate.getFullYear(),
      selectedMonths: [],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      years: [currentDate.getFullYear() + 1, currentDate.getFullYear() + 2], // Current year and next year
    };
  },
  methods: {
    startTimer() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }

      this.timerId = setInterval(() => {
        if (this.timeLeft <= 0) {
          clearInterval(this.timerId);
          this.otpExpired = true;
        } else {
          this.timeLeft--;
        }
      }, 1000);
    },

    async submitLead() {
      try {
        const requestData = {
          // name: this.form.name,
          full_name: this.filters.name,
          email: this.filters.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.filters.phone,
          // source: "associate-enquiry-form",
          // source: this.OnlyLocationName[0] + "-" + "enquiry-form",
          // state: this.form.state,
          // city: this.form.city,
          ls_id: 2,
          // m_id: 1,
          // c_id:1,
          category: "Student",
        };

        const response = await axios.post(
          `${LMS_API}/form-webhook/lead`,
          requestData
        );

        if (response.data.status) {
          console.log("Lead submitted successfully!");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
    async verifyOTP() {
      const enteredOTP = this.otp.join("");
      try {
        const res = await homeServices.verifyOtp({
          email: this.filters.email,
          otp: enteredOTP,
          name: this.filters.name,
          phone: this.filters.phone,
        });
        if (res.data.status) {
          //Crm api
          this.submitLead();
          this.show_verified = true;
          setTimeout(() => {
            this.$router.push("/search/search");
            this.show_verified = false;
          }, 3000);
          this.show_otp = false;
        } else {
          this.validationErrors.otp = "Invalid OTP";
          this.otp = Array(4).fill("");
          setTimeout(() => {
            this.validationErrors.otp = "";
          }, 2000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async sendCode() {
      try {
        // if (!this.validateEmail()) {
        //   return false;
        // }
        this.show_otp = true;
        this.otpExpired = false;
        this.startTimer();
        const res = await homeServices.getOtp({ email: this.filters.email });
        console.log(res);
        if (res.data.status) {
          // console.log("Otp sent");
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeOtp() {
      this.show_otp = false;
      this.timeLeft = 120; // Reset the timer value
      if (this.timerId) {
        clearInterval(this.timerId); // Clear the interval
        this.timerId = null;
      }
    },

    handleInput(index) {
      if (this.otp[index].length > 1) {
        this.$set(this.otp, index, this.otp[index].slice(0, 1));
      }
      if (this.otp[index].length === 1 && index < this.otp.length - 1) {
        this.$refs[`otp${index + 1}`][0].focus();
      }
    },
    handleKeyDown(event, index) {
      if (event.key === "Backspace" && !this.otp[index]) {
        if (index > 0) {
          this.$refs[`otp${index - 1}`][0].focus();
        }
      }
      if (event.key === "e") {
        event.preventDefault();
      }
    },

    validateEmail() {
      this.validationErrors.email = "";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!this.filters.email.trim()) {
        this.validationErrors.email = "Email is required";

        return false;
      } else if (!emailRegex.test(this.filters.email.trim())) {
        this.validationErrors.email = "Invalid email format";
        return false;
      }

      return true;
    },

    validateStep() {
      switch (this.currentStep) {
        case 2: // Countries
          if (this.filters.country_ids.length === 0) {
            this.validationErrors.countries =
              "Please select at least one country";
            return false;
          }
          break;

        case 3: // Course Levels
          if (this.filters.course_level_ids.length === 0) {
            this.validationErrors.courseLevels =
              "Please select at least one education level";
            return false;
          }
          break;

        case 4: // Years and Months
          if (
            this.filters.course_years.length === 0 ||
            this.filters.course_months.length === 0
          ) {
            this.validationErrors.yearMonth =
              "Please select at least one year and one month";
            return false;
          }
          break;

        case 1: // Specializations
          if (this.filters.field_ids.length === 0) {
            this.validationErrors.field =
              "Please select at least one specialization";
            return false;
          }
          break;
      }
      return true;
    },
    nextStep() {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++;
        this.saveFormState();
      }
    },
    proceedToNextStep() {
      let isValid = true;

      switch (this.currentStep) {
        case 1:
          isValid = this.validateStep();
          break;

        case 2:
          isValid = this.validateStep();
          break;

        case 3:
          isValid = this.validateStep();
          break;

        case 4:
          isValid = this.validateStep();
          break;
        case 5:
          isValid = this.validateEmail();
          break;
      }

      if (isValid) {
        if (this.currentStep < this.totalSteps) {
          this.currentStep++;
          this.saveFormState();
        }
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
        this.saveFormState();
      }
    },
    submitForm() {
      const finalStepValidation = this.validateStep();

      if (finalStepValidation) {
        localStorage.setItem("search_filters", JSON.stringify(this.filters));
        localStorage.setItem("visited", "true");
        this.submitLead();
        this.$router.push("/search/search");
      }
    },
    saveFormState(isFinal = false) {
      localStorage.setItem("search_filters", JSON.stringify(this.filters));
    },
    loadFormState() {
      const savedState = localStorage.getItem("search_filters");
      if (savedState) {
        const filters = JSON.parse(savedState);
        this.filters = {
          ...this.filters,
          ...filters,
        };

        this.filters.course_months = Array.isArray(this.filters.course_months)
          ? this.filters.course_months
          : [];
        this.filters.course_years = Array.isArray(this.filters.course_years)
          ? this.filters.course_years
          : [];
      }
    },

    ...mapActions([
      "onGetCountriesAndCities",
      "onGetCourseLevels",
      "onGetCourseCategories",
    ]),
    courseLevelSelected(id, name) {
      if (this.filters.course_level_ids.includes(id)) {
        this.filters.course_level_ids.splice(
          this.filters.course_level_ids.indexOf(id),
          1
        );
        this.filters.course_level_names.splice(
          this.filters.course_level_names.indexOf(name),
          1
        );
      } else {
        this.filters.course_level_ids.push(id);
        this.filters.course_level_names.push(name);
      }
      this.saveFormState();
    },
    courseCategorySelected(id, name) {
      if (this.filters.course_category_ids.includes(id)) {
        this.filters.course_category_ids.splice(
          this.filters.course_category_ids.indexOf(id),
          1
        );
        this.filters.course_category_names.splice(
          this.filters.course_category_names.indexOf(name),
          1
        );
      } else {
        this.filters.course_category_ids.push(id);
        this.filters.course_category_names.push(name);
      }
      this.saveFormState();
    },
    isCategorySelected(categoryId) {
      const category = this.formSpecialization.find(
        (cat) => cat.id === categoryId
      );
      if (!category) return false;

      return category.fields.every((field) =>
        this.filters.field_ids.includes(field.id)
      );
    },

    handleCategoryClick({ categoryId, categoryName, fieldIds }) {
      if (this.isCategorySelected(categoryId)) {
        this.filters.field_ids = this.filters.field_ids.filter(
          (id) => !fieldIds.includes(id)
        );
        this.filters.field_names = this.filters.field_names.filter(
          (name) =>
            !this.getCategoryFields(categoryId)
              .map((f) => f.name)
              .includes(name)
        );

        const categoryIndex =
          this.filters.course_category_ids.indexOf(categoryId);
        if (categoryIndex > -1) {
          this.filters.course_category_ids.splice(categoryIndex, 1);
          this.filters.course_category_names.splice(categoryIndex, 1);
        }
      } else {
        const newFields = fieldIds.filter(
          (id) => !this.filters.field_ids.includes(id)
        );
        this.filters.field_ids.push(...newFields);

        const category = this.formSpecialization.find(
          (cat) => cat.id === categoryId
        );
        const newFieldNames = category.fields
          .filter((field) => newFields.includes(field.id))
          .map((field) => field.name);
        this.filters.field_names.push(...newFieldNames);

        if (!this.filters.course_category_ids.includes(categoryId)) {
          this.filters.course_category_ids.push(categoryId);
          this.filters.course_category_names.push(categoryName);
        }
      }

      this.saveFormState();
    },

    handleFieldClick({ categoryId, fieldId, fieldName }) {
      const fieldIndex = this.filters.field_ids.indexOf(fieldId);

      if (fieldIndex > -1) {
        this.filters.field_ids.splice(fieldIndex, 1);
        this.filters.field_names.splice(fieldIndex, 1);

        const category = this.formSpecialization.find(
          (cat) => cat.id === categoryId
        );
        const hasSelectedFields = category.fields.some((field) =>
          this.filters.field_ids.includes(field.id)
        );

        if (!hasSelectedFields) {
          const categoryIndex =
            this.filters.course_category_ids.indexOf(categoryId);
          if (categoryIndex > -1) {
            this.filters.course_category_ids.splice(categoryIndex, 1);
            this.filters.course_category_names.splice(categoryIndex, 1);
          }
        }
      } else {
        this.filters.field_ids.push(fieldId);
        this.filters.field_names.push(fieldName);

        if (!this.filters.course_category_ids.includes(categoryId)) {
          const category = this.formSpecialization.find(
            (cat) => cat.id === categoryId
          );
          this.filters.course_category_ids.push(categoryId);
          this.filters.course_category_names.push(category.name);
          this.filters.search_text = this.filters.field_names[0];
        }
      }

      this.saveFormState();
    },

    getCategoryFields(categoryId) {
      const category = this.formSpecialization.find(
        (cat) => cat.id === categoryId
      );
      return category ? category.fields : [];
    },
    countrySelected(id, name) {
      if (this.filters.country_ids.includes(id)) {
        this.filters.country_ids.splice(
          this.filters.country_ids.indexOf(id),
          1
        );
        this.filters.country_names.splice(
          this.filters.country_names.indexOf(name),
          1
        );
      } else {
        this.filters.country_ids.push(id);
        this.filters.country_names.push(name);
      }
      this.saveFormState();
    },
    yearSelected(year) {
      const index = this.filters.course_years.indexOf(year);
      if (index > -1) {
        this.filters.course_years.splice(index, 1);
        this.filters.course_months = this.filters.course_months.filter(
          (month) => !this.getMonthsForYear(year).includes(month)
        );
      } else {
        this.filters.course_years.push(year);
      }

      console.log("Selected Years:", this.filters.course_years);
      console.log(
        "Selected Months after year change:",
        this.filters.course_months
      );
      this.saveFormState();
    },

    showOtp() {
      this.show_otp = !this.show_otp;
    },

    closeForm() {
      if (this.currentStep === this.totalSteps) {
        this.submitLead();
      }
      this.$router.push("/search/search");
    },

    monthSelected(month) {
      const index = this.filters.course_months.indexOf(month);
      if (index > -1) {
        this.filters.course_months.splice(index, 1);
      } else {
        console.log(month);
        this.filters.course_months.push(month);
      }
      this.saveFormState();
    },

    getMonthsForYear(year) {
      if (year === this.currentYear) {
        return this.months.slice(this.currentMonthIndex);
      } else if (year === this.currentYear + 1) {
        return this.months;
      } else if (year === this.currentYear + 2) {
        return this.months;
      }
      return [];
    },
  },
  computed: {
    timerDisplay() {
      if (this.timeLeft <= 0) {
        return "Code expired";
      }
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;
      return `Code expires in (${minutes}:${seconds
        .toString()
        .padStart(2, "0")})`;
    },
    filteredMonths() {
      if (this.selectedYear === this.currentYear) {
        return this.months.slice(this.currentMonthIndex + 1);
      } else if (this.selectedYear === this.currentYear + 1) {
        return this.months;
      }
      return [];
    },

    filteredSpecializations() {
      if (!this.searchTerm.trim()) {
        return this.formSpecialization;
      }

      const term = this.searchTerm.toLowerCase();

      return this.formSpecialization
        .map((category) => {
          const matchingFields = category.fields.filter((field) =>
            field.name.toLowerCase().includes(term)
          );
          if (category.name.toLowerCase().includes(term)) {
            return category;
          } else if (matchingFields.length > 0) {
            return {
              ...category,
              fields: matchingFields,
            };
          }
          return null;
        })
        .filter((category) => category !== null);
    },

    monthOptions() {
      return this.filteredMonths.map((month, index) => ({
        value: index + 1,
        text: month + " " + this.selectedYear,
      }));
    },

    ...mapGetters([
      "getCountriesAndCities",
      "getCourseLevels",
      "getCourseCategories",
    ]),
  },

  beforeMount() {
    this.onGetCountriesAndCities();
    this.onGetCourseLevels();
    this.onGetCourseCategories();
    this.loadFormState();
    if (localStorage.getItem("visited") === "true")
      this.$router.push("/search/search");
  },
  mounted() {},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.zoom-enter-active,
.zoom-leave-active {
  transition: transform 0.5s;
}
.zoom-enter {
  transform: scale(0.8);
}
.zoom-leave-to {
  transform: scale(1.2);
}

.flip-enter-active,
.flip-leave-active {
  transition: transform 0.6s;
}
.flip-enter {
  transform: rotateY(90deg);
}
.flip-leave-to {
  transform: rotateY(-90deg);
}

.main-div {
  padding-top: 100px;
  height: 100vh;
  /* background-image: url("~@/assets/imgs/multistepform/bgimg.jpg"); */
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.form {
  height: auto;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  /* height: 70%; */
  width: 80%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.progress-bar {
  height: 5px;
  background-color: #ddd;
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background-color: #4caf50;
  transition: width 0.3s ease;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.btn {
  padding: 10px 20px;
  width: 120px;
  border: 1px solid #ff7a00;
  border-radius: 5px;
  color: #ffa132;
  cursor: pointer;
  background-color: #fdf1f1;
}
.btn:hover {
  padding: 10px 20px;
  width: 120px;
  border: 1px solid #ff7a00;
  border-radius: 5px;
  background: linear-gradient(90deg, #ff7a00, #ff3d00) !important;
  cursor: pointer;
  color: #fdf1f1;
}
.step5 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.btn-success {
  background-color: #28a745;
}
.code-btn {
  font-size: 13px;
}

.question {
  text-align: center;
}
.arrow {
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.close {
  cursor: pointer;
  width: 20px;
  height: 18px;
}
.close-form {
  cursor: pointer;
  width: 20px;
  height: 18px;
  opacity: 50%;
  position: absolute;
  right: 10px;
  top: 5px;
}
.icons {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin: 20px 0;
  position: relative;
}
.title h5 {
  opacity: 50%;
}
.country {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}
.search input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 18px;
  margin-bottom: 10px;
}
.months {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.year {
  display: flex;
  flex-direction: column;
}
.input {
  border-radius: 20px;
  border: 1px solid #c0c0c0;
  outline: 0 !important;
  box-sizing: border-box;
  padding: 8px 15px;
}
.form-contact-div {
}

.form-ip {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  justify-content: start;
  align-items: center;
}

.form-label {
  font-size: 18px;
  color: #999;
  margin: 0;
}
.step1 {
  height: 400px;
  overflow-y: scroll;
  padding-right: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 20px;
}
.input-container {
  position: relative;
}

.input-container input,
.form button {
  outline: none;
  border: 1px solid #e5e7eb;
  margin: 8px 0;
}

.input-container input {
  background-color: #fff;
  padding: 1rem;
  padding-right: 3rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: 300px;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.input-container span {
  display: grid;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  place-content: center;
}

.input-container span svg {
  color: #9ca3af;
  width: 1rem;
  height: 1rem;
}
@media screen and (max-width: 768px) {
  .main-div {
    padding-top: 0px;
  }
  .form {
    height: auto;
    border-radius: 20px;
    width: 90%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .search input {
    width: 100%;
    padding: 0 10px;
    border: 1px solid #ccc;
    border-radius: 18px;
    margin-bottom: 10px;
  }

  h2 {
    font-size: 15px;
  }
  h5 {
    font-size: 12px;
  }
  .country {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    overflow-y: scroll;
    height: 250px;
  }

  .step3 {
    height: auto;
  }
  .error-message {
    font-size: 9px;
  }
  .progress-percent {
    font-size: 12px;
  }
  .question {
    text-align: start;
  }
  .otp-container {
    background-color: rgba(253, 253, 253, 0.493);
    padding: 2rem !important;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    text-align: center;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);

    width: 100%;
  }
  .otp-main {
    width: 100%;
    margin: 0 auto;
    max-width: 320px;
  }
  .step1 {
    height: 250px;
    overflow-y: scroll;
    padding-right: 20px;
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 20px;
    row-gap: 20px;
  }
}

@media screen and (min-width: 1200px) {
  .form {
    height: auto;
    border-radius: 20px;
    width: 60%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

/* otp / */

body {
  font-family: "Poppins", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  background-color: #e2d6d6;
  color: #e0e0e0;
  background-image: radial-gradient(
      circle at 25% 25%,
      rgba(166, 86, 246, 0.1) 2%,
      transparent 0%
    ),
    radial-gradient(
      circle at 75% 75%,
      rgba(102, 101, 241, 0.1) 2%,
      transparent 0%
    );
  background-size: 60px 60px;
}
.otp-main {
  z-index: 100;
}
.otp-container {
  background-color: rgba(253, 253, 253, 0.493);
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  text-align: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  /* max-width: 400px; */
  width: 100%;
}
.otp-container-v {
  background-color: rgba(253, 253, 253, 0.493);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  text-align: center;
  backdrop-filter: blur(10px);
  /* max-width: 400px; */
  width: 100%;
}
h1 {
  margin-bottom: 1.5rem;
  color: #000000;
  font-weight: 600;
  font-size: 2rem;
}
p {
  margin-bottom: 2rem;
  color: #000000;
  font-weight: 300;
}
.otp-input {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}
.otp-input input {
  width: 50px;
  height: 50px;
  margin: 0 8px;
  text-align: center;
  font-size: 1.5rem;
  border: 2px solid #6665f1;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.8);
  color: #000000;
  transition: all 0.3s ease;
}
.otp-input input:focus {
  border-color: #a556f6;
  box-shadow: 0 0 0 2px rgba(166, 86, 246, 0.3);
  outline: none;
}
.otp-input input::-webkit-outer-spin-button,
.otp-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.otp-input input[type="number"] {
  -moz-appearance: textfield;
}

.btn-sendcode {
  padding: 5px 5px;
  width: 80px;
  border: 1px solid #ff7a00;
  border-radius: 20px;
  color: #ffa132;
  cursor: pointer;
  background-color: #fdf1f1;
  font-size: 0.8rem;
  box-sizing: border-box;
}
.btn-sendcode:hover {
  background: linear-gradient(90deg, #ff7a00, #ff3d00) !important;
  border-radius: 20px;
  color: #fff;
  cursor: pointer;
}
@media (max-width: 768px) {
  .btn-sendcode {
    font-size: 0.7rem;
  }
}
@media (max-width: 500px) {
  .btn-sendcode {
    font-size: 0.6rem;
  }
}

#timer {
  font-size: 1rem;
  color: #6200c4;
  font-weight: 500;
  margin-left: 10px;
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.expired {
  animation: pulse 2s infinite;
  color: #ff4444;
}
.resend-text {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #b0b0b0;
}
.resend-link {
  color: #6665f1;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}
.resend-link:hover {
  color: #a556f6;
  text-decoration: underline;
}
#email {
  color: #a556f6;
  font-weight: 500;
}

.otp-main {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
}
.close-otp {
  position: absolute;
  top: 12px;
  right: 12px;
}

.div_image_v {
  background: #47c9a2;
  border-bottom: none;
  width: 100%;
  /* position: relative; */
  text-align: center;
  /* margin: -20px -20px 0; */
  border-radius: 5px 5px;
  padding: 35px;
}

.image {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  background-color: #e2feee;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  border-radius: 9999px;
  animation: animate 0.6s linear alternate-reverse infinite;
  transition: 0.6s ease;
}
.image svg {
  color: #0afa2a;
  width: 2rem;
  height: 2rem;
}
@keyframes animate {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.09);
  }
}

.div_text_v {
  color: #e2e7e3;
  font-weight: 600;
  margin-top: 20px;
  font-size: 20px;
}
.redirect {
  font-size: 10px;
  margin-top: 10px;
}
.text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/MultistepFormForFinder/MultiStepForm.vue